var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-4" }, [
    _c("div", { staticClass: "mb-4" }, [
      _c("p", [
        _c("span", {
          domProps: {
            innerHTML: _vm._s(
              _vm.Utils.t("modal.audioPlayer.vocalInstruction", {
                date: _vm.vocalDate(),
                time: _vm.vocalTime(),
              })
            ),
          },
        }),
        _vm._v(", \n      "),
        _c("span", [_vm._v(_vm._s(_vm.$t("global.by")))]),
        _vm._v(" "),
        _c("strong", [_vm._v(_vm._s(_vm.getDati.name))]),
        _vm._v(".\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex gap-3 align-items-center" }, [
      !_vm.hideControls
        ? _c(
            "div",
            [
              _c(
                "b-button",
                {
                  ref: "playButton",
                  staticClass: "bg-gray-100",
                  staticStyle: { width: "48px", height: "48px", padding: "0" },
                  attrs: {
                    variant: "light",
                    square: "",
                    size: "lg",
                    "aria-label": _vm.isPlaying
                      ? _vm.Utils.t("global.play")
                      : _vm.Utils.t("global.stop"),
                  },
                  on: { click: _vm.play },
                },
                [
                  _c("i", {
                    ref: "playButtonIcon",
                    staticClass: "zmdi",
                    class: [_vm.isPlaying ? "zmdi-stop" : "zmdi-play"],
                    staticStyle: { "font-size": "36px", "line-height": "48px" },
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-1 bg-gray-50 rounded-lg overflow-hidden" },
        [
          _c("div", { staticStyle: { position: "relative", left: "-2px" } }, [
            _c("div", {
              ref: "waveform",
              staticStyle: { inset: "1px -2px", position: "relative" },
            }),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }